import AntdSwitch from 'antd/lib/switch';
import styled from 'styled-components';

export const SameEdgeContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10rem',
});

export const SameEdgeText = styled.span(({ theme }) => ({
  display: 'block',

  fontSize: theme.typography.size14,
  color: theme.palette.darkLiver,
}));

export const Switch = styled(AntdSwitch)(({ theme }) => ({
  backgroundColor: theme.palette.superLightGray,

  '&:hover': {
    backgroundColor: `${theme.palette.darkLiver}90 !important`,
  },

  '&[aria-checked="true"]': {
    backgroundColor: theme.palette.darkLiver,
  },
}));
